import { merge } from 'lodash'
import { POST } from '@/api'
import tos from './tos'
import sct from './sct'
import available from './available'
import calendar from './calendar'

const SETTING = {
  // 受付状態 null:未契約, 0:停止中, 1:受付中
  status: {
    net: null,
    ivr: null,
  },
  // 受付期限
  // limit: 期限なしの場合null
  // day: 0（当日）から 30日前まで
  // hour: 1時 から 24時まで
  limit: {
    net: { day: null, hour: null },
    ivr: null,
  },
  // 外国語表示
  lang: {
    en: false,
  },
  company: {
    displayTerms: 0,
    name: {
      ja: null,
      en: null,
    },
    termsUrl: {
      ja: null,
      en: null,
    },
  },
  // 店舗情報
  store: {
    name: {
      ja: null,
      en: null,
    },
    tel: null,
    address: {
      ja: null,
      en: null,
    },
    url: null,
  },
  // 予約フォームURL
  url: null,
  // 予約不可表示
  rsvNotAvailableType: null,
  useGnaviCourse: 0,
  displayTableType: false,
  // その他テキスト
  otherTxt: {
    displayFlg: 0,
    ja: '',
    en: '',
  },
  // 利用タイプ
  usageType: 1,
}

export default {
  namespaced: true,
  state: {
    segment: null,
    setting: SETTING,
    busy: false,
    confirmed: false,
  },
  modules: {
    available,
    calendar,
    tos,
    sct,
  },
  mutations: {
    segment(state, segment) {
      state.segment = segment
    },
    set(state, setting) {
      state.setting = merge({}, SETTING, setting)
    },
    busy(state, busy = false) {
      state.busy = busy
    },
    confirmed(state, confirmed) {
      state.confirmed = confirmed
    },
  },
  actions: {
    async get({ commit, state }) {
      commit('busy', true)

      const res = await POST(`/${state.segment}/api/web/reception/setting`)
      if (res.status === 200) {
        commit('set', res.data)
      } else {
        commit('error/message', res.message, { root: true })
      }

      commit('busy', false)
      return res.status === 200
    },
  },
}
